import { render, staticRenderFns } from "./SmallLeftBigRight.vue.js?vue&type=template&id=18159ac4!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SmallLeftBigRight.vue?vue&type=template&id=18159ac4"
import script from "./SmallLeftBigRight.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SmallLeftBigRight.vue?vue&type=script&lang=js"
export * from "./SmallLeftBigRight.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SmallLeftBigRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports